module.exports = __webpack_public_path__ + "static/4-7d8e8e2afb9b8a6dc61c7854a7c55efa.png";